@if (label) {
  <ion-label [ngClass]="baseCssClass">
    {{ label }}
  </ion-label>
}

<ion-item [disabled]="true" [ngClass]="{ 'ion-margin-vertical': isMediumOrLarge(), hidden: !disabled }" lines="none">
  @if (icon) {
    <ion-icon [name]="icon" slot="start" color="gray"></ion-icon>
  }
  <ion-input
    [ngClass]="baseCssClass"
    [disabled]="true"
    value="{{ readOnlyValue }}"
  placeholder="No {{ label | lowercase }}"></ion-input>
</ion-item>

@if (!disabled) {
  <ion-grid>
    <form [formGroup]="form">
      <ion-row>
        <ion-col [size]="showScannerButton ? 10 : 12">
          <ion-row>
            <ion-col>
              <rc-single-select-form-field
                [formControlName]="rackFormField.city"
                label="City"
              [possibleValues]="getCityOptions()"></rc-single-select-form-field>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col>
              <rc-single-select-form-field
                [formControlName]="rackFormField.bay"
                label="Bay"
              [possibleValues]="getBayOptions()"></rc-single-select-form-field>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col>
              <rc-single-select-form-field
                [formControlName]="rackFormField.row"
                label="Row"
              [possibleValues]="getRowOptions()"></rc-single-select-form-field>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col>
              <rc-single-select-form-field
                [formControlName]="rackFormField.number"
                label="Number"
              [possibleValues]="getNumberOptions()"></rc-single-select-form-field>
            </ion-col>
          </ion-row>
        </ion-col>
        @if (showScannerButton) {
          <ion-col size="2" class="ion-text-right">
            <ion-button color="secondary" (click)="showScanModal()">
              <ion-icon name="scan-outline"></ion-icon>
            </ion-button>
          </ion-col>
        }
      </ion-row>
    </form>
  </ion-grid>
}
